import { defaultsDeep } from 'lodash';

const promiseCacheKey = 'uiUserSettings-promise';
const cacheKey = 'userSettingsService.uiUserSettings.v3';

export default class UserSettingsService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    cacheService,
    promiseCacheService,
    $q
  ) {
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.cacheService = cacheService;
    this.promiseCacheService = promiseCacheService;
    this.$q = $q;
  }

  getUserSettings() {
    const cachedValue = this.cacheService.get(cacheKey);
    
    if (cachedValue) {
      return this.$q.when(defaultsDeep({}, cachedValue));
    }

    return this.#getUserSettingsFromServer()
      .then((response) => {
        return defaultsDeep({}, response.data.settings);
      });
  }

  saveUserSettings(newSettings) {
    const url = this.serviceBaseUri + 'uiUserSettings';

    const data = { settings: newSettings };

    return this.getUserSettings().then((old) => {
      //only save if there has been a change
      if (!angular.equals(old, newSettings)) {
        return this.$http.post(url, data)
          .then((response) => {
            this.cacheService.set(cacheKey, response.data.settings);
            return angular.copy(response.data.settings);
          });
      } else {
        return this.$q.when(newSettings);
      }
    });

  }

  removeUserUISettingsFromCache() {
    this.cacheService.remove(cacheKey);
  }

  #getUserSettingsFromServer() {
    const url = this.serviceBaseUri + 'uiUserSettings';
    return this.promiseCacheService.getCallWithCachedPromise(promiseCacheKey, url, 0,
      (response) => {
        this.#purgeLegacyCallTags(response.data.settings);
        this.cacheService.set(cacheKey, response.data.settings);
      });
  }

  // The "Recent Tags" call annotation dropdown was removed. Its `callTags` map was
  // appended to on every annotation and never pruned, so strip it once from any
  // settings blob that still carries it. Mutates `settings` so the value we cache
  // and hand to callers is already clean.
  #purgeLegacyCallTags(settings) {
    if (!settings || !settings.callTags) {
      return;
    }

    delete settings.callTags;

    const url = this.serviceBaseUri + 'uiUserSettings';

    // Best effort - if it fails the purge just runs again on the next session.
    this.$http.post(url, { settings: settings }).catch(() => {
      //
    });
  }
}